export default __webpack_public_path__ + "static/media/store_type_blue_icon.42e96cb2.svg";